import styled from 'styled-components'
import { bp } from 'lib/core/resources/helpers/styled'

interface Props {
  textAlignment: string
  alignImageRight: boolean
  colorScheme: 'blue' | 'green' | 'pink'
}
export const Wrapper = styled.div<Props>`
  padding: 0 15px;
  max-width: 950px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  ${props => bp('sm', 'min-width')`
    flex-direction: ${props.alignImageRight ? 'row' : 'row-reverse'};
    align-items: center;
    grid-gap: 30px;
    font-size: 18px;
    line-height: 1.2;
    
    > * {
      flex: 1;
    }
  `}

  * {
    text-align: ${props => props.textAlignment};
  }

  img {
    max-width: 100%;
    height: auto;
  }

  h3 {
    ${props => props.theme.css.heading1};
    font-weight: ${props => props.theme.font.alt.bold};
    margin: 10px 0;
    color: ${props => props.colorScheme === 'pink' ? props.theme.productSelector.darkBg : props.colorScheme === 'blue' ? props.theme.productSelector.landingAccent : props.theme.productSelector.checkColor};
    ${bp('sm', 'min-width')`
      padding: 0 32% 0 0;
    `}
  }
`
